import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../../constants';

export default StyleSheet.create({
  flag: {
    width: 340,
    top: -10,
    left: -170,
   // borderWidth: 1,
   // borderColor: PALETTE.primaryActive,
    backgroundColor: "rgba(74,92,110,0.4)",
    paddingTop: 3,
    paddingBottom: 20,
    paddingHorizontal: 6,
    height: 100,
    boxShadow: "0.5px 0.5px 1px 0.5px #000",
    borderRadius: 1
  },
  flagDate: {
    color: PALETTE.secondaryActive,
    textAlign: 'center',
    marginTop: 13,
    fontSize: 20,
    //lineHeight: 26,
   // letterSpacing: 0.14
  },
  flagPrice: {
    color: PALETTE.secondaryActive,
    textAlign: 'center',
    marginTop: 8,
   // marginBottom: 20,
    fontSize: 20,
   // lineHeight: 24,
   // letterSpacing: 0.07
  },
});
